
import type { BaseErrorResponse, GetPlansRes, UpdatePlanReq } from './data-contracts';
import type { RequestParams } from './http-client';
import { ContentType, HttpClient } from './http-client';


export default function usePlan() {
  class Plan<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
    /**
     * No description
     *
     * @tags Plan
     * @name PlanControllerGetPlans
     * @summary Returns plan properties
     * @request GET:/api3/plan
     * @secure
     * @response `200` `GetPlansRes`
     * @response `400` `BaseErrorResponse`
     */
    planControllerGetPlans = (params: RequestParams = {}) =>
      this.request<GetPlansRes, BaseErrorResponse>({
        path: '/api3/plan',
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Plan
     * @name PlanControllerEditPlan
     * @summary Update plan
     * @request PUT:/api3/plan
     * @secure
     * @response `200` `GetPlansRes`
     * @response `400` `BaseErrorResponse`
     */
    planControllerEditPlan = (data: UpdatePlanReq, params: RequestParams = {}) =>
      this.request<GetPlansRes, BaseErrorResponse>({
        path: '/api3/plan',
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      });
  }

  return new Plan();
}
